export default __webpack_public_path__ + "static/INSTYLE_mobile@3x-37fc13230fe727dbe7abf4254a87118e.png";